/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import { numberDoubleExp } from "../../../utils/regularExpressions";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 150,
  },
});

class F402InventoryItemStockForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      recordId: 0,

      categoriesData: [],
      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      itemsData: [],
      itemsDataLoading: false,
      itemId: "",
      itemIdError: "",

      quantity: "",
      quantityError: "",

      remarks: "",
      remarksError: "",

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getData(
      "GET",
      "/inventory/C402CommonInventoryItemsCategoriesView",
      null,
      "categoriesData",
      "categoriesDataLoading"
    );
  }

  getData = async (
    method = "",
    endpoint = "",
    data = null,
    stateName = "",
    loadingStateName = ""
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      method,
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      data,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";
    let regex = "";
    switch (name) {
      case "quantity":
        regex = new RegExp(numberDoubleExp);
        if (value) {
          if (!regex.test(value)) {
            return;
          }
        }
        break;
      case "categoryId":
        if (value) {
          this.getData(
            "POST",
            `/inventory/C402CommonInventoryItemsByCategoryIdView?categoryId=${value}`,
            null,
            "itemsData",
            ""
          );
          this.setState({
            itemId: "",
            itemIdError: "",
          });
        } else {
          this.setState({
            itemsData: [],
            itemsDataLoading: false,
            itemId: "",
            itemIdError: "",
          });
        }
        break;
      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  isFormValid = () => {
    let { categoryIdError, itemIdError, remarksError, quantityError } =
      this.state;
    let isValid = true;

    if (!this.state.categoryId) {
      isValid = false;
      categoryIdError = "Please select category.";
    } else {
      categoryIdError = "";
    }

    if (!this.state.itemId) {
      isValid = false;
      itemIdError = "Please select item id.";
    } else {
      itemIdError = "";
    }

    if (!this.state.quantity) {
      isValid = false;
      quantityError = "Please enter quantity.";
    } else {
      quantityError = "";
    }

    if (!this.state.remarks) {
      isValid = false;
      remarksError = "Please enter remarks.";
    } else {
      remarksError = "";
    }

    this.setState({
      categoryIdError,
      itemIdError,
      remarksError,
      quantityError,
    });

    return isValid;
  };

  onViewAllButtonClick = () => {
    window.location = "#/R403InventoryItemStockView";
  };

  submitForm = async (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });

    if (this.isFormValid()) {
      const data = new FormData();
      data.append("recordId", this.state.recordId);
      data.append("categoryId", this.state.categoryId);
      data.append("itemId", this.state.itemId);
      data.append("remarks", this.state.remarks);
      data.append("quantity", this.state.quantity);
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/inventory/C402CommonInventoryItemsRequistionSave`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        this.clearAllData();
        this.handleSnackbar(true, "Save Successfully", "success");
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  clearAllData = () => {
    this.setState({
      recordId: 0,

      categoriesData: [],
      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      itemsData: [],
      itemsDataLoading: false,
      itemId: "",
      itemIdError: "",

      quantity: "",
      quantityError: "",

      remarks: "",
      remarksError: "",
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <NavBar isAuthorize />
        <div className={classes.root}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              color="primary"
              style={{ fontWeight: 700 }}
            >
              Items Stock Form
            </Typography>
          </Grid>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <div className={classes.topMargin}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  id="categoryId"
                  name="categoryId"
                  fullWidth
                  label="Category"
                  variant="outlined"
                  onChange={this.handleChange}
                  value={this.state.categoryId}
                  error={!!this.state.categoryIdError}
                  helperText={this.state.categoryIdError}
                >
                  {this.state.categoriesData.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || ""}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  id="itemId"
                  name="itemId"
                  variant="outlined"
                  fullWidth
                  label="Item"
                  onChange={this.handleChange}
                  value={this.state.itemId}
                  error={!!this.state.itemIdError}
                  helperText={this.state.itemIdError}
                >
                  {this.state.itemsData.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || ""}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="off"
                  id="quantity"
                  name="quantity"
                  variant="outlined"
                  label="Quantity"
                  onChange={this.handleChange}
                  value={this.state.quantity}
                  error={!!this.state.quantityError}
                  helperText={this.state.quantityError}
                  fullWidth
                ></TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="off"
                  id="remarks"
                  name="remarks"
                  label="Remarks"
                  variant="outlined"
                  onChange={this.handleChange}
                  value={this.state.remarks}
                  error={!!this.state.remarksError}
                  helperText={this.state.remarksError}
                  fullWidth
                ></TextField>
              </Grid>
              <Grid align="end" style={{ marginTop: 10 }} item xs={12} sm={12}>
                <Button
                  onClick={(e) => this.submitForm(e)}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <CircularProgress
                      size={23}
                      style={{ color: "white", fontWeight: 600 }}
                    />
                  ) : (
                    "Save Stock"
                  )}
                </Button>
                <Button
                  className={classes.button}
                  color="primary"
                  variant="outlined"
                  disabled={this.state.isLoading}
                  onClick={() => this.onViewAllButtonClick()}
                >
                  View All
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }
}

F402InventoryItemStockForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(F402InventoryItemStockForm);
